import { render, staticRenderFns } from "./designer-filter.vue?vue&type=template&id=573d2b99&scoped=true"
import script from "./designer-filter.vue?vue&type=script&lang=js"
export * from "./designer-filter.vue?vue&type=script&lang=js"
import style0 from "./designer-filter.vue?vue&type=style&index=0&id=573d2b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d2b99",
  null
  
)

export default component.exports